import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const FlagUS = () => (
    <svg width="16" height="12" viewBox="0 0 16 12" className="inline-block">
      <rect width="16" height="12" fill="#B22234"/>
      <rect width="16" height="1" y="1" fill="white"/>
      <rect width="16" height="1" y="3" fill="white"/>
      <rect width="16" height="1" y="5" fill="white"/>
      <rect width="16" height="1" y="7" fill="white"/>
      <rect width="16" height="1" y="9" fill="white"/>
      <rect width="16" height="1" y="11" fill="white"/>
      <rect width="6" height="7" fill="#3C3B6E"/>
    </svg>
  );

  const FlagDE = () => (
    <svg width="16" height="12" viewBox="0 0 16 12" className="inline-block">
      <rect width="16" height="4" fill="#000000"/>
      <rect width="16" height="4" y="4" fill="#DD0000"/>
      <rect width="16" height="4" y="8" fill="#FFCE00"/>
    </svg>
  );

  const languages = [
    { code: 'en', name: 'English', flag: <FlagUS /> },
    { code: 'de', name: 'Deutsch', flag: <FlagDE /> }
  ];

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <div className="flex items-center gap-2">
      {languages.map((language) => (
        <button
          key={language.code}
          onClick={() => handleLanguageChange(language.code)}
          className={`flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium transition-colors duration-200 ${
            i18n.language === language.code
              ? 'bg-primary-blue text-white'
              : 'bg-bg-light text-text-gray hover:bg-bg-white hover:text-primary-blue border border-border-light'
          }`}
          title={language.name}
        >
          <span className="flex items-center">{language.flag}</span>
          <span className="hidden sm:inline">{language.code.toUpperCase()}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;